import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TablePagination } from "../../../../../../common/details-table/table-pagination.component";
import { DEFAULT_PAGE_VALUE, MODAL_CUSTOM_MESSAGE, COST_ALLOCATION_TYPE } from "../../../../../../../constants/external-constants";
import { glCodeHistoryActions } from '../../../../../../../store/external/finance/glcode-details/gl-code-history.reducer';
import { costCenterHistoryActions } from "../../../../../../../store/external/finance/history/cost-center-history.reducer";

class CostAllocationHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }

    componentDidMount() {
        this.props.getGlCodeHistoryLogs(this.props.glCodeId);
        this.props.getCostCenterHistoryLogs(this.props.costCodeId);
    }

    componentWillUnmount() {
        this.props.resetGlCodeHistory();
        this.props.resetCostCenterHistory();
    }


    resizePage = (pageSize) => {
        const { resizeGlCodeHistoryLogs, getGlCodeHistoryLogs, glCodeId, resizeCostCenterHistoryLogs, getCostCenterHistoryLogs, costCodeId } = this.props;
        resizeGlCodeHistoryLogs(pageSize);
        getGlCodeHistoryLogs(glCodeId);
        resizeCostCenterHistoryLogs(pageSize);
        getCostCenterHistoryLogs(costCodeId);  
    }

    paginationAction = (pageIndex) => {
        const { getGlCodeHistoryLogs, glCodeId, getCostCenterHistoryLogs, costCodeId } = this.props;
        getGlCodeHistoryLogs(glCodeId, pageIndex);
        getCostCenterHistoryLogs(costCodeId, pageIndex); 
    }

    onColumnSearch = () => {
        const { getGlCodeHistoryLogs, glCodeId, getCostCenterHistoryLogs, costCodeId } = this.props;
        getGlCodeHistoryLogs(glCodeId, 0);
        getCostCenterHistoryLogs(costCodeId, 0); 
    }

    render() {
        const { setCostCenterHistoryColSearchStr, setGlCodeHistoryColSearchStr, costCenterHistory, glCodeHistory, costAllocationType } = this.props;

        const searchData = costAllocationType == COST_ALLOCATION_TYPE.GlCode ? setGlCodeHistoryColSearchStr : setCostCenterHistoryColSearchStr;
        const historyData = costAllocationType == COST_ALLOCATION_TYPE.GlCode ? glCodeHistory : costCenterHistory;
        const { IsLoadingTable } = historyData;
        const { Headers, Data, Pagination } = historyData.HistoryTable;

        return (
            <>

                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}
                    pages={Pagination}
                    paginationAction={this.paginationAction}
                    onColumnSearch={this.onColumnSearch}
                    onColumnSearchChange={searchData}
                    isColSearchShow={this.props.isColSearchShow}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isNotSortable={true}
                    isLoading={IsLoadingTable}
                    hideStatusIcon={true}       
                /> 
            </>
        );
    }
}

export default connect(
    state => {
        const { glCodeHistory, costCenterHistory, costCenter } = state;
        return {
            glCodeHistory,
            costCenterHistory,
            costCenter
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, glCodeHistoryActions, costCenterHistoryActions),
        dispatch
    )
)(CostAllocationHistory);
